export function initVariantsButtonsSelection() {


    const variantSelection = document.querySelector('.js-variantButtons');

    if (!variantSelection) {
        return;
    }

    const variantButtons = variantSelection.querySelectorAll('.js-variantButton');

    if (variantButtons.length === 0) {
        return;
    }

    for (let button of variantButtons) {
        button.addEventListener('click', () => {
            handleVariantButtonClick(button);
        });
    }

}

function parseGrid(root) {
    const script = root.querySelector('.variant-grid');
    if (!script) return null;
    try {
        return JSON.parse(script.textContent.trim());
    } catch (e) {
        return null;
    }
}

function disableAllButtons() {
    const variantButtons = document.querySelectorAll('.js-variantButton');
    for (let button of variantButtons) {
        button.classList.add('is-disabled');
        button.classList.remove('is-selected');
        button.disabled = true;
    }
}

function setSelected(group, value) {
    group.querySelectorAll('.js-variantButton').forEach((btn) => {
        const isSelected = (btn.dataset.year === value) || (btn.dataset.volume === value);
        btn.classList.toggle('is-selected', isSelected);
    });
}

function getSelected(root) {
    const yearBtn = root.querySelector('[data-group="year"] .is-selected');
    const volumeBtn = root.querySelector('[data-group="volume"] .is-selected');
    return {
        year: yearBtn ? yearBtn.dataset.year : null,
        volume: volumeBtn ? volumeBtn.dataset.volume : null
    };
}

function normVol(v) {
    return String(v).trim().toUpperCase();
}

function firstAvailableYearForVolume(grid, volume) {
    const vKey = normVol(volume);
    return Object.keys(grid).find(y => grid[y]?.[vKey]?.disabled === false) || null;
}

function firstAvailableVolumeForYear(grid, year) {
    const row = grid[String(year).trim()] || {};
    return Object.keys(row).find(k => row[k]?.disabled === false) || null;
}

function resolveLink(grid, year, volume, simpleMode) {
    if (!grid) return null;

    if (simpleMode === 'true') {
        const vKey = normVol(volume);
        const cell = grid[vKey];
        return cell && !cell.disabled ? cell.link : null;
    }

    if (!year || !volume) return null;
    const row = grid[String(year).trim()];
    if (!row) return null;
    const cell = row[normVol(volume)];
    return cell && !cell.disabled ? cell.link : null;
}

function handleVariantButtonClick(button) {
    const btn = button;
    if (!btn || btn.classList.contains('is-disabled') || btn.classList.contains('is-selected')) return;


    const root = btn.closest('.js-variantButtons');
    if (!root) return;

    const group = btn.closest('[data-group]');
    if (!group) return;

    const isYear = btn.dataset.year !== undefined;
    const isVolume = btn.dataset.volume !== undefined;

    if (isYear) setSelected(group, btn.dataset.year);
    if (isVolume) setSelected(group, btn.dataset.volume);

    const grid = parseGrid(root);
    const simpleMode = root.dataset.simple || 'false';
    let selected = getSelected(root);

    // Wenn Jahr gewechselt und aktuelles Volume für dieses Jahr nicht verfügbar → erstes verfügbares nehmen
    if (isYear && grid && simpleMode !== 'true') {
        const year = String(selected.year).trim();
        const volKey = selected.volume ? normVol(selected.volume) : null;
        const row = grid[year] || {};
        if (!volKey || !row[volKey] || row[volKey].disabled !== false) {
            const fav = firstAvailableVolumeForYear(grid, year);
            if (fav) {
                const volumeGroup = root.querySelector('[data-group="volume"]');
                if (volumeGroup) setSelected(volumeGroup, fav);
                selected = getSelected(root);
            }
        }
    }

    // Wenn Volume geklickt und aktuelles Jahr hat dieses Volume nicht → erstes verfügbares Jahr nehmen
    if (isVolume && grid && simpleMode !== 'true') {
        const volKey = normVol(selected.volume);
        const year = String(selected.year).trim();
        const row = grid[year] || {};
        if (!row[volKey] || row[volKey].disabled !== false) {
            const favY = firstAvailableYearForVolume(grid, selected.volume);
            if (favY) {
                const yearGroup = root.querySelector('[data-group="year"]');
                if (yearGroup) setSelected(yearGroup, favY);
                selected = getSelected(root);
            }
        }
    }

    disableAllButtons();
    btn.classList.remove('is-disabled');
    btn.classList.add('is-loading');

    const link = resolveLink(grid, selected.year, selected.volume, simpleMode);
    if (link) {
        window.location.href = link;
    }
}
